import {
	GET_TOP_IMMEDIATE_OTS_REQUEST,
	GET_TOP_IMMEDIATE_OTS_SUCCESS,
	GET_TOP_IMMEDIATE_OTS_ERROR
} from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_TOP_IMMEDIATE_OTS_REQUEST:
			return {
				loading: true,
			};
		case GET_TOP_IMMEDIATE_OTS_SUCCESS:
			return {
				...state,
				loading: false,
				payload
			};
		case GET_TOP_IMMEDIATE_OTS_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};

		default:
			return state;
	}
}
